import { render, staticRenderFns } from "./DateIsToday.vue?vue&type=template&id=3288af3d&scoped=true"
import script from "./DateIsToday.vue?vue&type=script&lang=js"
export * from "./DateIsToday.vue?vue&type=script&lang=js"
import style0 from "./DateIsToday.vue?vue&type=style&index=0&id=3288af3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3288af3d",
  null
  
)

export default component.exports